import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
/**
 * AuthGuard prevents authenticated users from accessing anonymous routes (Login, SignUp).
 */
export class NoAuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private auth: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.auth.currentUser) {
            // User is logged in so we redirect to home
            this.router.navigate(['/']);
            return false;
        }
        // User is not logged in
        return true;
    }
}
